import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Disposisi = () => {
    const columns = [
        {
            name: 'ID Disposisi',
            cell: row => row['idDisposisi']
        },
        {
            name: 'Nama Disposisi',
            cell: row => row['nmDisposisi'] 
        },
        {
            name: 'Keterangan Disposisi',
            cell: row => row['ketDisposisi'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listDisposisi, setlistDisposisi] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistDisposisi = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listDisposisi(null, page, size)
            setlistDisposisi(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistDisposisi([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistDisposisi(0, 10)
    }, [getlistDisposisi])

    const handleChangePage = (page) => {
        getlistDisposisi(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listDisposisi(null, page - 1, size)
        setlistDisposisi(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Disposisi</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listDisposisi}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default Disposisi